module.exports = __webpack_public_path__ + "img/amu-logo.07856b00.jpg";